import { IDataItem, Utils, Enums } from '@wix/promotions-types';
import { HttpClient } from '@wix/yoshi-flow-editor';
import { getViewerEssentials } from '../../viewer-utils';

interface UpdateCampaignI {
  instance: string;
  campaignId: string;
  campaign: IDataItem;
  context?: string;
}

export const updateCampaign = async ({
  instance,
  campaignId,
  campaign,
  context,
}: UpdateCampaignI) => {
  const httpClient = new HttpClient();
  const { Apis } = Enums.getAutoApiEndpoints(getViewerEssentials().flowAPI);
  Utils.DataItemApi(instance, httpClient)
    .updateDataItem(campaignId, campaign, Apis)
    .then((campaign) => {
      return campaign;
    })
    .catch((e) => console.log('updateCampaign fail', context, { e, campaign }));
};
